/* eslint-disable jsx-a11y/label-has-associated-control */
import { useState } from 'react';
import toast from 'react-hot-toast';
import { Link, useNavigate } from 'react-router-dom';
import Center from '../../assets/styles/Center';
import FormContainer from '../../assets/styles/FormContainer';
import ChangePageAuth from '../../components/ChangePageAuth';
import FormAuth from '../../components/FormAuth';
import GroupCheck from '../../components/GroupCheck';
import GroupInput from '../../components/GroupInput';
import Title from '../../components/Title';
import useErrors from '../../hooks/useErrors';
import { useRegisterUser } from '../../hooks/mutations/useUserMutations';
import { useStore } from '../../stores';

export default function ClientRegister() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [termAccept, setTermAccept] = useState(false);
  const [emailAccept, setEmailAccept] = useState(false);

  const navigate = useNavigate();
  const login = useStore((state) => state.login);
  const { mutate: registerUser, isPending } = useRegisterUser();

  const { setError, removeError, getErrorMessageByFieldName, errors } =
    useErrors();

  function handleEmail(e) {
    setEmail(e.target.value);

    if (!e.target.value) {
      setError({ field: 'email', message: 'O email é nescessário!' });
    } else {
      removeError('email');
    }
  }

  function handlePassword(e) {
    setPassword(e.target.value);
  }

  function handlePasswordConfirm(e) {
    setPasswordConfirm(e.target.value);

    if (e.target.value !== password) {
      setError({
        field: 'passwordConfirm',
        message: 'As senhas não coincidem',
      });
    } else {
      removeError('passwordConfirm');
    }
  }

  function handleTermAccept(e) {
    setTermAccept(e.target.checked);
  }

  function handleEmailAccept(e) {
    setEmailAccept(e.target.checked);
  }

  function onSubmit() {
    if (!password) {
      setError({ field: 'password', message: 'A senha é obrigátoria' });
      return;
    }

    if (errors.length !== 0) {
      return;
    }

    const body = {
      email,
      password,
      type: 'client',
      email_accept: emailAccept,
    };

    registerUser(body, {
      onSuccess: ({ token, user }) => {
        const bodyLogin = {
          token,
          id: user.id,
          email: user.email,
          type: user.type,
        };

        login(bodyLogin);
        navigate('/modelregister/v5');
      },
      onError: (error) => {
        switch (error.response?.data?.error) {
          case 'O email já está registrado':
            setError({ field: 'email', message: error.response?.data?.error });
            break;

          case 'Email e senha são obrigatórios':
            setError({ field: 'email', message: error.response?.data?.error });
            setError({ field: 'password', message: error.response?.data?.error });
            break;

          default:
            toast.error('Erro ao registrar conta!');
            break;
        }
      },
    });
  }

  const isFormValid =
    Boolean(password && passwordConfirm) && errors.length === 0;

  return (
    <FormContainer>
      <Center className="center">
        <Title
          title="Crie sua conta. 100% Gratuito e sigiloso"
          subtitle="Seus dados estão 100% seguro"
        />

        <FormAuth
          onSubmit={onSubmit}
          // onGoogle={() => alert('Falta o google')}
          // googleText="Cadastrar-se com o Google"
          buttonTitle="Criar conta"
          buttonLinkText="Já possui conta? Entre agora!"
          buttonLink="/clientlogin"
          isLoading={isPending}
          formValid={isFormValid}
        >
          <GroupInput error={getErrorMessageByFieldName('email')}>
            <label>Email*</label>
            <input
              type="email"
              placeholder="Digite seu email*"
              value={email}
              onChange={handleEmail}
            />
          </GroupInput>

          <GroupInput password>
            <label>Senha*</label>
            <input
              type="text"
              placeholder="Digite a sua senha*"
              value={password}
              onChange={handlePassword}
            />
          </GroupInput>

          <GroupInput
            password
            error={getErrorMessageByFieldName('passwordConfirm')}
          >
            <label>Confirme a senha*</label>
            <input
              type="text"
              placeholder="Confirme a sua senha*"
              value={passwordConfirm}
              onChange={handlePasswordConfirm}
            />
          </GroupInput>

          <div className="group">
            <GroupCheck check={termAccept}>
              <input
                type="checkbox"
                checked={termAccept}
                onChange={handleTermAccept}
              />
              <label>Li e aceito os</label>
              <Link to="/term">termos de uso</Link>
            </GroupCheck>

            <GroupCheck check={emailAccept}>
              <input
                type="checkbox"
                checked={emailAccept}
                onChange={handleEmailAccept}
              />
              <label>Quero receber novidades por email</label>
            </GroupCheck>
          </div>
        </FormAuth>

        <ChangePageAuth
          link="/modelregister"
          text="É uma acompanhante? Cadastre-se"
        />
      </Center>
    </FormContainer>
  );
}
